import { format, getTime, formatDistanceToNow, formatDistanceToNowStrict, addDays } from 'date-fns';
import getDateLocale from './getDateLocale';
import i18n from '../locales/i18n';
// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'dd/MM/yyyy');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd/MM/yyyy HH:mm', {
    addSuffix: true,
    locale: getDateLocale()

  });
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fTime(date) {
  return format(new Date(date), 'hh:mm');
}

export function fToNow(date) {
  return formatDistanceToNowStrict(new Date(date), {
    addSuffix: false,
    locale: getDateLocale()

  });
}

export function isDateValid(dateString) {
  // Tenta criar um objeto de data com a string fornecida
  const date = new Date(dateString);

  // Verifica se a data é válida
  return !isNaN(date) && date.toString() !== '';
}

function isToday(date) {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
}

/**
 * Verifica se uma data é amanhã
 * @param {Date} date - A data a ser verificada
 * @returns {boolean} Verdadeiro se a data for amanhã
 */
function isTomorrow(date) {
  const tomorrow = addDays(new Date(), 1);
  return (
    date.getDate() === tomorrow.getDate() &&
    date.getMonth() === tomorrow.getMonth() &&
    date.getFullYear() === tomorrow.getFullYear()
  );
}

export function formatarData(date) {
  console.log('dataAlvo', date)
  // Assegura que estamos trabalhando com um objeto Date
  const dataAlvo = new Date(date);


  // Verifica se é hoje
  if (isToday(dataAlvo)) {
    return i18n.t('common:dates.today');
  }

  // Verifica se é amanhã
  if (isTomorrow(dataAlvo)) {
    return i18n.t('common:dates.tomorrow');
  }

  // Para os demais dias, retorna o dia da semana
  return format(dataAlvo, 'EEEE', { locale: getDateLocale() })
    // Capitaliza a primeira letra
    .replace(/^(\w)(\w+)(.*)$/, (_, primeira, resto) =>
      primeira.toUpperCase() + resto);
}
